import { RootState } from '../../../../init-store';
import { selectSelfMutedStateByKind } from '../../../pages/call/selectors';
import { selectIsTestplane } from '../flags/selectors';
import { isMobileUa } from '../uatraits';
import { DeviceKind } from './slice';
import { DeviceErrorCode } from './types';

export const getAudioInputError = (state: Partial<RootState>): Maybe<DeviceErrorCode> => {
    return state.deviceManager?.audioinput;
};

export const getAudioOutputError = (state: Partial<RootState>): Maybe<DeviceErrorCode> => {
    return state.deviceManager?.audiooutput;
};

export const getVideoInputError = (state: Partial<RootState>): Maybe<DeviceErrorCode> => {
    return state.deviceManager?.videoinput;
};

export const getDeviceErrorByKind = (state: Partial<RootState>, kind: DeviceKind): Maybe<DeviceErrorCode> => {
    return state.deviceManager?.[kind];
};

export const selectDeviceErrorModalVisibility = (state: Partial<RootState>, kind: DeviceKind) => {
    return state?.deviceManager?.modalVisibility?.[kind];
};

export const selectShouldShowDeviceErrorModal = (state: RootState, kind: DeviceKind) => {
    const isMuted = selectSelfMutedStateByKind(state, kind);
    const isError = getDeviceErrorByKind(state, kind);
    const isTestplane = selectIsTestplane(state);
    const isMobile = isMobileUa(state);
    return !(isTestplane && isMobile) && isError && isMuted;
};
